import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../../styles/css/components/disclosures_v2.css";

const CAB = () => (
  <div className="disclosure-page">
    <Helmet>
      <title>Fig Loans Texas LLC CAB License | Fig Loans</title>
      <link rel="canonical" href="https://www.figloans.com/cab" />
      <meta
        name="description"
        content="Fig Loans Texas LLC is a Credit Access Business registered with the State of Texas Consumer Credit Division."
      />
      <meta
        property="og:description"
        content="Fig Loans Texas LLC is a Credit Access Business registered with the State of Texas Consumer Credit Division."
      />
      <meta name="robots" content="noindex" />
    </Helmet>

    <div className="disclosure-container">
      <div className="disclosure-header">
        <h1>Credit Access Business Disclosure</h1>
      </div>

      <div className="disclosure-section">
        <p>
        Fig Loans Texas, LLC will not be the lender for loans received at this
        site. Fig Loans Texas, LLC is a Credit Access Business. We will attempt
        to arrange a loan between you and a third party lender, and service that
        loan once it is issued. Any questions, service issues or complaints
        about your loan will be addressed by Fig Loans Texas, LLC and not the
        lender.
        <br />
        <br />
        Your Credit Access Business ("CAB") fee average over the term of your
        loan will be $10.10 per $100.00 borrowed each month (see examples below
        for total effective Loan APR<sup>1</sup>). Your specific CAB fee will be
        calculated based on the outstanding loan principal each month. You will
        also be charged interest by your lender of 10% APR on the loan
        principal.
        <br />
        <br />
        For all loans, your CAB fees will not be reduced if you are delinquent
        in any loan or CAB fee payments. You will be required to pay the
        applicable, unreduced CAB fee each month until you become current on
        your obligations to repay the loan and your obligations to pay CAB fees.
      </p>

      <h3>Fee Examples</h3>

        <table className="disclosure-table">
          <thead>
            <tr>
              <th>Amount Advanced</th>
              <th>$300.00</th>
              <th>$400.00</th>
              <th>$500.00</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Loan Length</strong></td>
              <td>120 days</td>
              <td>120 days</td>
              <td>120 days</td>
            </tr>
            <tr>
              <td><strong>Loan APR<sup>2</sup></strong></td>
              <td>190%</td>
              <td>190%</td>
              <td>190%</td>
            </tr>
            <tr>
              <td><strong>CAB fees</strong></td>
              <td>$121.19</td>
              <td>$161.55</td>
              <td>$201.94</td>
            </tr>
            <tr>
              <td><strong>Interest Charge</strong></td>
              <td>$6.25</td>
              <td>$8.33</td>
              <td>$10.42</td>
            </tr>
            <tr>
              <td><strong>Total Repayment Amount</strong></td>
              <td>$427.44</td>
              <td>$569.88</td>
              <td>$712.36</td>
            </tr>
          </tbody>
        </table>

        <p className="footnote">
        2. The APR is based on a four payment, 120 day amortizing loan. The APR
        shown is based on the federal Truth in Lending Act and does not reflect
        specialized state APR calculations, if any.
        <br />
        </p>
      </div>

      <div className="disclosure-section">
        <h3>Optional Fees</h3>
        <p>
          You have the option of paying using a debit card. If you make a payment
          with a debit card, you will be charged a 3% processing fee that will be
          automatically added to your total payment.
        </p>
      </div>

      <div className="disclosure-section">
        <h3>Lender's Privacy Policy</h3>
        <p>
          <Link to="/privacy">
            Fig Loans Texas, LLC and Third Party Lender Privacy Policy
          </Link>
        </p>
      </div>

      <div className="disclosure-section">
        <h3>Notices</h3>
        <p>
        This business—Fig Loans Texas, LLC—is licensed and examined by the State
        of Texas - Office of Consumer Credit Commissioner. Call the Consumer
        Credit Hotline or write for credit information or assistance with credit
        problems.
        </p>

        <p>
          If you have any additional concerns, please reach out to:{" "}
          <a
            href="https://occc.texas.gov/consumers/complaint-resolution"
            className="disclosure_popup"
            target="_blank"
            rel="noopener noreferrer"
          >
            OCCC Consumer Complaints
          </a>
        </p>

        <p>
          Office of Consumer Credit Commissioner: <br />
          2601 North Lamar Boulevard
          <br />
          Austin, Texas 78705-4207
          <br />
          <br />
          Phone: (800) 538-1579 (toll-free)
          <br />
          Email: consumer.complaints@occc.state.tx.us
          <br />
          Website: www.occc.state.tx.us
        </p>
      </div>
    </div>
  </div>
);

export default CAB;
